import React, { useRef } from 'react';
import { useFirebaseAuth } from 'helpers/hooks/useFirebaseAuth';
import { createContext, useContext } from 'react';

export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

const registeredFunctionRef = useRef(null);

const registerFunction = (fn) => {
  registeredFunctionRef.current = fn;
};

const callRegisteredFunction = (...args) => {
  if (registeredFunctionRef.current) {
    registeredFunctionRef.current(...args);
  }
};

const auth = useFirebaseAuth(callRegisteredFunction);
  
  return (
    <AuthContext.Provider value={{...auth, registerFunction}}>
      {children}
    </AuthContext.Provider>
  );
};